module.exports = __webpack_public_path__ + "img/gjxx1.de0e610f.png";